// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-downloads-js": () => import("./../src/templates/downloads.js" /* webpackChunkName: "component---src-templates-downloads-js" */)
}

